import { Component, h, Prop, State } from '@stencil/core'

type Location = 'top-left' | 'top-right' | 'bottom-right' | 'bottom-left'

@Component({
  tag: 'impersonation-popover',
})
export class ImpersonationPopover {
  @Prop() impersonatedUserEmail: string
  @Prop() stopImpersonatingUrl: string

  @State() location: Location = 'top-left'

  nextLocation() {
    switch (this.location) {
      case 'top-left':
        this.location = 'top-right'
        break
      case 'top-right':
        this.location = 'bottom-right'
        break
      case 'bottom-right':
        this.location = 'bottom-left'
        break
      case 'bottom-left':
        this.location = 'top-left'
        break
    }
  }

  get locationClasses() {
    switch (this.location) {
      case 'top-left':
        return 'top-2 left-2'
      case 'top-right':
        return 'top-2 right-2'
      case 'bottom-right':
        return 'bottom-2 right-2'
      case 'bottom-left':
        return 'bottom-2 left-2'
    }
  }

  render() {
    return (
      <div
        class={`
          flex flex-row justify-center items-center fixed spacing-x-6px text-black bg-info-error p-2 rounded-md
          ${this.locationClasses}
        `}
        style={{ 'z-index': '9999' }}
      >
        <span>
          You are impersonating <span class='font-bold'>{this.impersonatedUserEmail}</span>
        </span>

        <form method='post' action={this.stopImpersonatingUrl}>
          <csrf-token />
          <button class='p-1 text-sm font-semibold rounded border-2 border-black spacing-x-4px'>
            <ui-icon icon='eye-slash-fill' class='align-middle' size='xl' />
            <span>Stop Impersonating</span>
          </button>
        </form>

        <button
          class='p-1 text-sm font-semibold rounded border-2 border-black spacing-x-4px'
          onClick={() => this.nextLocation()}
        >
          <ui-icon icon='arrows-move' class='align-middle' size='xl' />
        </button>
      </div>
    )
  }
}
